import React from "react";
import VisitFormActions from "./VisitFormActions";
import { Space } from "antd";

const VisitPopoverContent = ({ visit }) => {
  return (
    <Space direction="vertical" className="visit-blocks-popover-content-wrapper">
      {visit?.serviceForms.map((form,index) => (
        <VisitFormActions form={form} visit={visit} key={index}/>
      ))}
    </Space>
  );
};

export default VisitPopoverContent;
